import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { MultiChoiceDataElement } from '../../../core/elements/models/multi-choice-data-element';
import { MultiChoiceElement } from '../assist-data-element.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SelectedCondition } from '../../../core/models/executed-result.model';
import { SimulatorEngineService } from '../../../core/services/simulator-engine.service';
const $ = require('jquery');

@Component({
  selector: 'acr-assist-multi-choice-element',
  template: `<form [formGroup]="multiChoiceElementForm" novalidate>
  <div class="form-group">
    <div class="col-sm-5 text-right">
      <label class="control-label break-word">{{multiChoiceElement.label}} <span *ngIf="multiChoiceElement.unit != undefined && multiChoiceElement.unit != ''"> ({{multiChoiceElement.unit}})</span>
      </label>
      <ng-container *ngIf="multiChoiceElement.hint !== '' && multiChoiceElement.hint !== undefined">
        <i class="fa fa-info-circle text-primary whitespace" title="{{multiChoiceElement.hint}}"></i>
      </ng-container>
      <ng-container *ngIf="multiChoiceElement.diagrams != undefined ">
        <acr-hint-diagram [dataElement]="multiChoiceElement" [imagePath]="imagePath"></acr-hint-diagram>
      </ng-container>
      <ng-container *ngIf="multiChoiceElement.isRequired">
      <span *ngIf="multiChoiceElementForm.controls['multiCheckBox'].invalid && !multiChoiceValues.length" class="required-field"
        title="Required Field">
        *
      </span>
    </ng-container>
    </div>
    <div class="col-sm-7" [ngClass]="multiChoiceElement.isEditable == false ? 'disabled-element' : ''">
      <div *ngFor="let choice of multiChoiceElement.choiceInfo" class="checkbox checkboxCustomized" title="{{choice.hint}}">
        <label [hidden]="multiChoiceElement.ChoiceNotRelevant != undefined ? 
        multiChoiceElement.ChoiceNotRelevant.indexOf(choice.value) > -1 ? true: null
        : null">
          <input type="checkbox" id="{{multiChoiceElement.id}}_{{choice.value}}" [checked]="false" formControlName="multiCheckBox"
            value="{{choice.value}}" (change)="updateMultiChoice(multiChoiceElement.id, multiChoiceElement.label, (choice.reportText !== undefined) ? choice.reportText : choice.label, $event)">
          {{choice.label}}
        </label>
      </div>
    </div>
  </div>
</form>`,
  styles: [`.checkboxCustomized{min-height:0!important;padding-top:0!important}.disabled-element{cursor:not-allowed}.disabled-element:before{content:"";z-index:1;position:absolute;top:0;right:0;bottom:0;left:0;background-color:rgba(255,255,255,.8)}`, `.required-field{color:red}.padding-l-5{padding-left:5px}.whitespace{margin-left:5px}.max-w-h-100{max-width:100%;max-height:100%}.carousel-control>.fa{font-size:40px;position:absolute;top:50%;z-index:5;display:inline-block;margin-top:-20px}.carousel-control.left{background-repeat:repeat-x}.carousel-control.left,.carousel-control.right{background-image:none}.carousel-control.right{background-image:linear-gradient(to right,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5) 100%);background-repeat:repeat-x}.scroll{overflow-y:scroll;overflow-x:hidden}.div-simulator-form-height{height:calc(100vh - 100px);overflow-y:scroll;overflow-x:hidden}.div-report-text-scroll{overflow-x:hidden;overflow-y:auto;max-height:calc(100vh - 300px)}.padding-r-10{padding-right:10px}.slide-left{left:30px}.slide-right{right:30px}hr{margin-top:10px;margin-bottom:10px}.white-space-line{white-space:pre-line;word-wrap:break-word}p{margin:0 0 10px}.form-control{border-radius:0;box-shadow:none;border-color:#d2d6de}h4.modal-title.float-left{float:left}.margin-b-0{margin-bottom:0}.font-weight-400{font-weight:400}.custom-radio-style{float:left;margin-right:15px}.zoom{width:100%;overflow:auto}.zoom img{height:auto;width:100%;min-width:100%;max-width:inherit!important}.btn-zoom{background-color:#f4f4f4;color:#444;border-color:#ddd}.btn-zoom.hover,.btn-zoom:active,.btn-zoom:hover{background-color:#e7e7e7}@media (min-width:768px){label.control-label{padding-left:20px}}.padding-5{padding:5px}`]
})
export class AssistMultiChoiceElementComponent implements OnInit, AfterViewInit {
  @Input() multiChoiceElement: MultiChoiceDataElement;
  @Input() imagePath: string;
  @Output() returnMultiChoice = new EventEmitter();
  multiElements: MultiChoiceElement[] = [];
  multiChoiceValues: string[] = [];
  multiChoiceComaprisonValues: string[] = [];
  multiChoiceElementForm: FormGroup;
  selectedCondition: SelectedCondition;
  choiceValue: string[] = [];

  constructor(private formBuilder: FormBuilder, private simulatorEngineService: SimulatorEngineService) { }

  ngOnInit() {
    this.createMultiChoiceElementForm();
  }
  ngAfterViewInit(): void {

    if (this.multiChoiceElement.currentValue !== undefined) {
      const values: any = [];
      const labels: any = [];
      for (const choice in this.multiChoiceElement.choiceInfo) {
        if (Array.isArray(this.multiChoiceElement.currentValue)) {
          for (const currValue of this.multiChoiceElement.currentValue) {
            if (currValue === this.multiChoiceElement.choiceInfo[choice].value && this.multiChoiceElement.choiceInfo[choice].value !== undefined) {
              this.choiceValue = this.multiChoiceElement.currentValue;
              $('#' + this.multiChoiceElement.id + '_' + this.multiChoiceElement.choiceInfo[choice].value).prop('checked', true);
              values.push(currValue);
              labels.push(this.multiChoiceElement.choiceInfo[choice].label);
              break;
            }
          }
        } else {
          if (this.multiChoiceElement.currentValue === this.multiChoiceElement.choiceInfo[choice].value && this.multiChoiceElement.choiceInfo[choice].value !== undefined) {
            this.choiceValue = this.multiChoiceElement.currentValue;
            $('#' + this.multiChoiceElement.id + '_' + this.multiChoiceElement.currentValue).prop('checked', true);
            values.push(this.multiChoiceElement.currentValue);
            labels.push(this.multiChoiceElement.choiceInfo[choice].label);
          }
        }
      }
      this.selectedMultiChoice(this.multiChoiceElement.id, this.multiChoiceElement.label, values, labels);
    } else {
      this.returnMultiChoice.emit(undefined);
    }
  }

  selectedMultiChoice(elementId: string, selectedCondition: string, choiceValue: any, choiceLabel: any) {
    const multiElement = new MultiChoiceElement();
    if ($('#' + elementId + '_' + choiceValue).is(':checked')) {
      this.multiChoiceValues = choiceLabel;
      this.multiChoiceComaprisonValues = choiceValue;
    } else {
      const index = this.multiChoiceValues.indexOf(choiceLabel);
      const comparisonIndex = this.multiChoiceComaprisonValues.indexOf(choiceValue);
      if (index > -1) {
        this.multiChoiceValues.splice(index, 1);
      }
      if (comparisonIndex > -1) {
        this.multiChoiceComaprisonValues.splice(comparisonIndex, 1);
      }
    }
    multiElement.elementId = elementId;
    multiElement.selectedValues = this.multiChoiceValues;
    multiElement.selectedComparisonValues = this.multiChoiceComaprisonValues;

    this.selectedCondition = new SelectedCondition();

    this.selectedCondition.selectedConditionId = elementId;
    this.selectedCondition.selectedCondition = selectedCondition;
    this.selectedCondition.selectedValue = this.multiChoiceValues;
    this.returnMultiChoice.emit({ receivedElement: multiElement, selectedCondition: this.selectedCondition });
  }

  updateMultiChoice(elementId: string, selectedCondition: string, value: string, event) {
    const multiElement = new MultiChoiceElement();
    if (event.currentTarget.checked) {
      this.multiChoiceValues.push(value);
      this.multiChoiceComaprisonValues.push(event.currentTarget.value);
    } else {
      const index = this.multiChoiceValues.indexOf(value);
      const comparisonIndex = this.multiChoiceComaprisonValues.indexOf(event.currentTarget.value);
      if (index > -1) {
        this.multiChoiceValues.splice(index, 1);
      }
      if (comparisonIndex > -1) {
        this.multiChoiceComaprisonValues.splice(comparisonIndex, 1);
      }
    }
    multiElement.elementId = elementId;
    multiElement.selectedValues = this.multiChoiceValues;
    multiElement.selectedComparisonValues = this.multiChoiceComaprisonValues;

    this.selectedCondition = new SelectedCondition();

    this.selectedCondition.selectedConditionId = elementId;
    this.selectedCondition.selectedCondition = selectedCondition;
    this.selectedCondition.selectedValue = this.multiChoiceValues;
    this.returnMultiChoice.emit({ receivedElement: multiElement, selectedCondition: this.selectedCondition });
  }

  private createMultiChoiceElementForm() {
    this.multiChoiceElementForm = this.formBuilder.group({
      multiCheckBox: ['', Validators.required],
    }, {
        validator: this.specificValueInsideRange('multiCheckBox')
      });
  }

  private specificValueInsideRange(checkBoxKey: string) {
    return (group: FormGroup) => {
      const choiceControl = group.controls[checkBoxKey];
      if (this.multiChoiceElement.isRequired) {
        return choiceControl.setErrors({ notEquivalent: true });
      } else {
        return choiceControl.setErrors(null);
      }
    };
  }
}
